import { useState } from "react";
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Input,
} from "@heroui/react";
import { fetchWithAuth } from "shared/api/fetch-with-auth";
import { API_URL } from "constants/index";
import { useSession } from "@clerk/clerk-react";
import { toast } from "react-toastify";

interface CreateTypeModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
}

export const CreateTypeModal: React.FC<CreateTypeModalProps> = ({
  isOpen,
  onClose,
  onSuccess
}) => {
  const { session } = useSession();
  const [typeName, setTypeName] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const resetForm = () => {
    setTypeName("");
  };

  const handleCreate = async () => {
    if (!typeName.trim()) {
      toast.error("Module naam is verplicht");
      return;
    }

    setIsLoading(true);
    try {
      const response = await fetchWithAuth(
        `${API_URL}/mail-templates/types`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ name: typeName }),
        },
        session
      );

      if (response.ok) {
        toast.success("Module succesvol aangemaakt");
        resetForm();
        onClose();
        onSuccess();
      } 
    } catch (error) {
      console.error("Error creating type:", error);
      toast.error("Fout bij aanmaken van module");
    } finally {
      setIsLoading(false);
    }
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  return (
    <Modal 
      isOpen={isOpen} 
      onClose={handleClose}
      size="md"
    >
      <ModalContent>
        <ModalHeader>
          <h3 className="text-lg font-semibold">Nieuwe module aanmaken</h3>
        </ModalHeader>
        <ModalBody>
          <Input
            label="Module naam"
            placeholder="Bijv. Helpdesk, Verzekering, Follow-up"
            value={typeName}
            onChange={(e) => setTypeName(e.target.value)}
            isRequired
            autoFocus
          />
        </ModalBody>
        <ModalFooter>
          <Button variant="light" onPress={handleClose}>
            Annuleren
          </Button>
          <Button 
            className="bg-moss-primary text-white" 
            onPress={handleCreate}
            isLoading={isLoading}
          >
            Module aanmaken
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}; 